(function () {
    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('lodash'),
            require('../../../enums/email.js')
        );
    } else {

        RivalIQ.apps.Registration.module('data', function () {});
        RivalIQ.apps.Registration.data.accountDefaults = exportFn(window._, RivalIQ.enums.email);
    }

    function exportFn(_, emailEnum) {

        function reportsToSchedule(email, landscapeId) {
            return [];
        }

        function defaultUserSettings(landscapeId) {
            const userSettings = {
                landscapes: {}
            };
            userSettings.landscapes[landscapeId] = {
                email: {
                    enabled: _.cloneDeep(emailEnum.defaultSettings)
                }
            };

            return userSettings;
        }

        return {
            reportsToSchedule: reportsToSchedule,
            defaultUserSettings: defaultUserSettings
        };
    }
})();
